import React from "react";
import Loader from "../loader/Loader";

const TopMaterialProduced = ({
  loading,
  itemwiseProduction = [],
}) => {
  return (
    <div className="card mt-4">
      <div className="card-body">
        <strong className="fs-4">
          Itemwise Production (Top 5 Products)
        </strong>

        <div className="table-responsive mt-3">
          <table className="custom-table">
            <thead>
              <tr>
                <th>PRODUCT</th>
                <th>MONTHLY TARGET</th>
                <th>MTD PRODUCTION</th>
                <th>EFFICIENCY</th>
                <th>STATUS</th>
              </tr>
            </thead>

            {loading ? (
              <tbody>
                <tr>
                  <td colSpan="5" className="text-center py-4">
                    <Loader />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {itemwiseProduction.length > 0 ? (
                  itemwiseProduction.map((item, idx) => {
                    const productionPercentage = Number(
                      item?.production_percentage ?? 0
                    );

                    let status = "At Risk";
                    let statusClass =
                      "bg-danger-subtle text-danger";

                    if (productionPercentage >= 90) {
                      status = "On Track";
                      statusClass =
                        "bg-success-subtle text-success";
                    } else if (productionPercentage >= 70) {
                      status = "Watch";
                      statusClass =
                        "bg-warning-subtle text-warning";
                    }

                    return (
                      <tr
                        key={item?.product?.id ?? idx}
                      >
                        {/* PRODUCT */}
                        <td>
                          <strong>
                            {item?.product?.name ?? "-"}
                          </strong>
                        </td>

                        {/* MONTHLY TARGET */}
                        <td className="text-nowrap">
                          {item?.total_qty_pending ?? 0} units
                        </td>

                        {/* MTD PRODUCTION */}
                        <td className="text-nowrap">
                          {item?.total_produced ?? 0} units
                        </td>

                        {/* EFFICIENCY */}
                        <td>
                          <strong>
                            {productionPercentage.toFixed(2)} %
                          </strong>
                        </td>

                        {/* STATUS */}
                        <td>
                          <span
                            className={`badge px-3 py-2 rounded-pill ${statusClass}`}
                            style={{
                              fontWeight: "500",
                            }}
                          >
                            {status}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="text-center py-4 text-muted"
                    >
                      No production data found.
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};

export default TopMaterialProduced;